/**
 * A custom element in charge of adding base JS functionality to the footer.
 * Examples: all footer tracking, updating footer content when a BBB changes.
 *
 * @module iabbb-footer
 */
class Footer extends HTMLElement {
  connectedCallback() {
    this.addAnalyticsEventListeners();
  }

  disconnectedCallback() {
    this.removeAnalyticsEventListeners();
  }

  addAnalyticsEventListeners = () => {
    const logo = this.querySelector('[data-logo-link]');
    logo.addEventListener('click', this.handleLogoClick);

    const mainLinks = this.querySelectorAll('.main .dtm-footer-link');

    for (const mainLink of mainLinks) {
      mainLink.addEventListener('click', this.handleMainLinkClick);
    }

    const bottomLinks = this.querySelectorAll('.bottom .dtm-footer-link');

    for (const bottomLink of bottomLinks) {
      bottomLink.addEventListener('click', this.handleBottomLinkClick);
    }

    const socialLinks = this.querySelectorAll('.main .dtm-footer-social-link');

    for (const socialLink of socialLinks) {
      socialLink.addEventListener('click', this.handleSocialLinkClick);
    }
  };

  removeAnalyticsEventListeners = () => {
    const logo = this.querySelector('[data-logo-link]');
    logo.removeEventListener('click', this.handleLogoClick);

    const mainLinks = this.querySelectorAll('.main .dtm-footer-link');

    for (const mainLink of mainLinks) {
      mainLink.removeEventListener('click', this.handleMainLinkClick);
    }

    const bottomLinks = this.querySelectorAll('.bottom .dtm-footer-link');

    for (const bottomLink of bottomLinks) {
      bottomLink.removeEventListener('click', this.handleBottomLinkClick);
    }

    const socialLinks = this.querySelectorAll('.main .dtm-footer-social-link');

    for (const socialLink of socialLinks) {
      socialLink.removeEventListener('click', this.handleSocialLinkClick);
    }
  };
}

customElements.define('iabbb-footer', Footer);
